(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('media-gallery').forEach(g=>{
const viewer=g.querySelector('[id^="GalleryViewer"]');if(!viewer)return;
new ResizeObserver(()=>g.style.setProperty('--vr-viewer-height',viewer.offsetHeight+'px')).observe(viewer);
g.addEventListener('click',e=>{const b=e.target.closest('[data-vr-gallery-step]');if(!b)return;const slides=[...viewer.querySelectorAll('.product__media-item[data-media-id]')];const selected=g.querySelector('.thumbnail[aria-current="true"]')?.closest('[data-target]')?.dataset.target;let index=slides.findIndex(s=>s.dataset.mediaId===selected);if(index<0)index=slides.findIndex(s=>s.classList.contains('is-active'));const next=slides[(index+Number(b.dataset.vrGalleryStep)+slides.length)%slides.length];if(next&&typeof g.setActiveMedia==='function')g.setActiveMedia(next.dataset.mediaId,false);});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vr-gemstone-accordions"] && !Shopify.designMode) return;
  try {
    function vrPrepareDetails(scope){
  scope.querySelectorAll('[data-vr-pd]:not([data-ready])').forEach(root=>{
    const source=root.querySelector('[data-vr-pd-body]');
    if(!source)return;
    const units=[];
    const collect=node=>{
      if(node.nodeType===1&&node.tagName==='DIV'&&!node.id&&!node.querySelector('input,button,select,textarea,script,iframe,video,form,details')){
        [...node.childNodes].forEach(collect);
      }else units.push(node);
    };
    [...source.childNodes].forEach(collect);
    if(root.hasAttribute('data-heading-sections')){
      const output=document.createDocumentFragment();
      const groups=[];
      const labelFor=text=>{
        if(/^(details|specifications|product details)\s*:?$/i.test(text))return root.dataset.specifications;
        if(/^(check availability|availability)\s*:?$/i.test(text))return root.dataset.availability;
        if(/^description\s*:?$/i.test(text))return root.dataset.description;
        return text;
      };
      let group={title:root.dataset.description,nodes:[]};
      groups.push(group);
      units.forEach(node=>{
        if(node.nodeType===1&&node.tagName==='H3'){
          group={title:labelFor((node.textContent||'').trim()),nodes:[]};
          groups.push(group);
        }else group.nodes.push(node);
      });
      const displayGroups=[];
      const mergedGroups=new Map();
      groups.forEach(group=>{
        if(!root.hasAttribute('data-clean-gemstone')){displayGroups.push(group);return;}
        if(/^(draft review notes|internal notes|review notes)\s*:?$/i.test(group.title))return;
        const key=group.title.replace(/\s+/g,' ').trim().toLowerCase();
        if(mergedGroups.has(key))mergedGroups.get(key).nodes.push(...group.nodes);
        else{mergedGroups.set(key,group);displayGroups.push(group);}
      });
      displayGroups.forEach(group=>{
        const fragment=document.createDocumentFragment();
        group.nodes.forEach(node=>fragment.appendChild(node));
        fragment.querySelectorAll('script,style,link,meta').forEach(node=>node.remove());
        if(root.hasAttribute('data-clean-gemstone')){
          fragment.querySelectorAll('hr').forEach(node=>node.remove());
          const seen=new Set();
          [...fragment.children].forEach(node=>{
            const key=node.outerHTML;
            if(seen.has(key))node.remove();else seen.add(key);
          });
        }
        if(!fragment.textContent.replace(/[\s\u200B-\u200D\uFEFF]/g,'')&&!fragment.querySelector('img,video,iframe,svg,audio'))return;
        fragment.querySelectorAll('*').forEach(node=>{
          ['style','class','color','face','size'].forEach(attribute=>node.removeAttribute(attribute));
        });
        const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
        summary.textContent=group.title||root.dataset.description;
        body.className='vr-pd-body rte';
        body.appendChild(fragment);
        details.append(summary,body);
        output.appendChild(details);
      });
      root.replaceChildren(output);
      root.hidden=!output.childNodes.length&&root.childNodes.length===0;
      root.dataset.ready='true';
      return;
    }
    const groups=new Map();
    let current='description';
    const add=(key,node)=>{
      if(!groups.has(key))groups.set(key,document.createDocumentFragment());
      groups.get(key).appendChild(node);
    };
    units.forEach(node=>{
      const text=(node.textContent||'').replace(/\s+/g,' ').trim();
      const tag=node.nodeType===1?node.tagName:'';
      if(/^(why\s+\d+\s*k|materials?\b|craftsmanship\b)/i.test(text)&&text.length<100)current='materials';
      else if(/^(check availability|availability|please contact us to confirm)/i.test(text))current='availability';
      else if(/^(shipping|delivery|returns?|customization|if you would like|if you’d like|if you would|ship in|ships in)/i.test(text))current='service';
      else if(/^(details|specifications|product details)\s*:?$/i.test(text))current='specifications';
      else if(['UL','OL','TABLE'].includes(tag))current='specifications';
      else if(/^please note:|^the diamond weight/i.test(text))current='specifications';
      add(current,node);
    });
    const output=document.createDocumentFragment();
    groups.forEach((fragment,key)=>{
      if(!fragment.textContent.trim()&&!fragment.querySelector('img,video,iframe,svg,table,input,button'))return;
      const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
      summary.textContent=root.dataset[key];
      body.className='vr-pd-body rte';
      body.appendChild(fragment);
      details.append(summary,body);output.appendChild(details);
    });
    if(output.childNodes.length){root.replaceChildren(output);root.dataset.ready='true';}
  });
}
vrPrepareDetails(document);
document.addEventListener('shopify:section:load',event=>vrPrepareDetails(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vr-product-accordions"] && !Shopify.designMode) return;
  try {
    function vrPrepareDetails(scope){
  scope.querySelectorAll('[data-vr-pd]:not([data-ready])').forEach(root=>{
    const source=root.querySelector('[data-vr-pd-body]');
    if(!source)return;
    const units=[];
    const collect=node=>{
      if(node.nodeType===1&&node.tagName==='DIV'&&!node.id&&!node.querySelector('input,button,select,textarea,script,iframe,video,form,details')){
        [...node.childNodes].forEach(collect);
      }else units.push(node);
    };
    [...source.childNodes].forEach(collect);
    if(root.hasAttribute('data-heading-sections')){
      const output=document.createDocumentFragment();
      const groups=[];
      const labelFor=text=>{
        if(/^(details|specifications|product details)\s*:?$/i.test(text))return root.dataset.specifications;
        if(/^(check availability|availability)\s*:?$/i.test(text))return root.dataset.availability;
        if(/^description\s*:?$/i.test(text))return root.dataset.description;
        return text;
      };
      let group={title:root.dataset.description,nodes:[]};
      groups.push(group);
      units.forEach(node=>{
        if(node.nodeType===1&&node.tagName==='H3'){
          group={title:labelFor((node.textContent||'').trim()),nodes:[]};
          groups.push(group);
        }else group.nodes.push(node);
      });
      groups.forEach(group=>{
        const fragment=document.createDocumentFragment();
        group.nodes.forEach(node=>fragment.appendChild(node));
        fragment.querySelectorAll('script,style,link,meta').forEach(node=>node.remove());
        if(!fragment.textContent.replace(/[\s\u200B-\u200D\uFEFF]/g,'')&&!fragment.querySelector('img,video,iframe,svg,audio'))return;
        fragment.querySelectorAll('*').forEach(node=>{
          ['style','class','color','face','size'].forEach(attribute=>node.removeAttribute(attribute));
        });
        const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
        summary.textContent=group.title||root.dataset.description;
        body.className='vr-pd-body rte';
        body.appendChild(fragment);
        details.append(summary,body);
        output.appendChild(details);
      });
      root.replaceChildren(output);
      root.hidden=!output.childNodes.length&&root.childNodes.length===0;
      root.dataset.ready='true';
      return;
    }
    const groups=new Map();
    let current='description';
    const add=(key,node)=>{
      if(!groups.has(key))groups.set(key,document.createDocumentFragment());
      groups.get(key).appendChild(node);
    };
    units.forEach(node=>{
      const text=(node.textContent||'').replace(/\s+/g,' ').trim();
      const tag=node.nodeType===1?node.tagName:'';
      if(/^(why\s+\d+\s*k|materials?\b|craftsmanship\b)/i.test(text)&&text.length<100)current='materials';
      else if(/^(check availability|availability|please contact us to confirm)/i.test(text))current='availability';
      else if(/^(shipping|delivery|returns?|customization|if you would like|if you’d like|if you would|ship in|ships in)/i.test(text))current='service';
      else if(/^(details|specifications|product details)\s*:?$/i.test(text))current='specifications';
      else if(['UL','OL','TABLE'].includes(tag))current='specifications';
      else if(/^please note:|^the diamond weight/i.test(text))current='specifications';
      add(current,node);
    });
    const output=document.createDocumentFragment();
    groups.forEach((fragment,key)=>{
      if(!fragment.textContent.trim()&&!fragment.querySelector('img,video,iframe,svg,table,input,button'))return;
      const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
      summary.textContent=root.dataset[key];
      body.className='vr-pd-body rte';
      body.appendChild(fragment);
      details.append(summary,body);output.appendChild(details);
    });
    if(output.childNodes.length){root.replaceChildren(output);root.dataset.ready='true';}
  });
}
vrPrepareDetails(document);
document.addEventListener('shopify:section:load',event=>vrPrepareDetails(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vrm-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vrm-gallery')) {
 customElements.define('vrm-gallery', class extends HTMLElement {
  connectedCallback() {
   this.typeSelect=this.querySelector('[data-vrm-type]');this.stoneSelect=this.querySelector('[data-vrm-stone]');
   this.apply=()=>{let shown=0;this.querySelectorAll('[data-vrm-item]').forEach(item=>{const types=(item.dataset.type||'').split(' ');const visible=(!this.typeSelect||this.typeSelect.value==='all'||types.includes(this.typeSelect.value))&&(!this.stoneSelect||this.stoneSelect.value==='all'||item.dataset.stone===this.stoneSelect.value);item.hidden=!visible;if(visible)shown++;});const empty=this.querySelector('[data-vrm-empty]');if(empty)empty.hidden=shown>0;};
   this.fromHash=()=>{const value=location.hash.slice(1);const target=this.stoneSelect||this.typeSelect;if(target&&Array.from(target.options).some(o=>o.value===value))target.value=value;this.apply();};
   this.onChange=()=>{history.replaceState(null,'','#'+(this.stoneSelect||this.typeSelect).value);this.apply();};
   this.addEventListener('change',this.onChange);window.addEventListener('hashchange',this.fromHash);this.fromHash();
  }
  disconnectedCallback(){this.removeEventListener('change',this.onChange);window.removeEventListener('hashchange',this.fromHash);}
 });
}
  } catch(e) { console.error(e); }
})();

})();
